import { render } from "./AdminCreator.vue?vue&type=template&id=0dff3d29&scoped=true"
import script from "./AdminCreator.vue?vue&type=script&lang=js"
export * from "./AdminCreator.vue?vue&type=script&lang=js"

import "./AdminCreator.vue?vue&type=style&index=0&id=0dff3d29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dff3d29"]])

export default __exports__